<div [ngClass]="{selected: selected}" class="col s12" id= "{{'consr_vto_vis-filter-tile_'+selected+'_btn'}}">
    <i class="filter-icon visucloud-icons" [ngClass]="filterIcon">
    </i>
    <p truncated [(isDisabled)]="isDisabled" [matTooltipDisabled]="isDisabled" id="{{filterIcon}}" matTooltip="{{filterTileText | translate}}" matTooltipPosition="below">
        {{filterTileText | translate}}
    </p>
</div>
